import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/esnext.promise.all-settled.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { ref, computed, onMounted } from 'vue';
import { VBtn, VList, VListItem, VListItemContent, VListItemIcon, VListItemTitle, VMenu, VSkeletonLoader } from 'vuetify/lib';
import * as Constants from '@/constants';
import { NEWS_CATEGORIES_DIRECTORIES, PUBLISHER_SUB_MENUS } from './site-menu-constants';
import { DocumentTypeEnum } from 'wklr-backend-sdk/models';
import { generateSearchRoute } from '@/utils/routeUtils';
import { scrollToTop } from '@/utility';
import { useDomain } from '@/plugins/domain';
import { useRepositories } from '@/plugins/repositories';
import { useStore } from '@/store/useStore';
import { useToast } from '@/plugins/vueToast';
import { useAuth } from '@/plugins/auth';
import AccountMenuList from '@/components/renewal/header/account-menu-list.vue';
import HelpMenuList from '@/components/renewal/header/help-menu-list.vue';
import Icon from '@/components/renewal/common/icon.vue';
import SiteMenuHistory from '@/components/renewal/header/site-menu-history.vue';
import SiteMenuSub from '@/components/renewal/header/site-menu-sub.vue';
import { buildFirstGroupMenu, buildSecondGroupMenu, buildThirdGroupMenu } from './site-menu-builder';
export default /*#__PURE__*/_defineComponent({
  __name: 'site-menu',
  setup: function setup(__props) {
    var router = useRouter();
    var domain = useDomain();
    var $repositories = useRepositories();
    var toast = useToast();
    var auth = useAuth();

    // =================
    // メニュー
    // =================
    var isShowMenu = ref(false);

    // アニメーション用
    var animationDuration = 300;
    var isSubMenuShowing = ref(false);
    var isSubMenuHiding = ref(false);
    var startShowingSubMenu = function startShowingSubMenu(callback) {
      isSubMenuShowing.value = true;
      setTimeout(function () {
        isSubMenuShowing.value = false;
      }, animationDuration);

      // アニメーションさせるために少し待つ
      setTimeout(callback, 100);
    };
    var startHidingSubMenu = function startHidingSubMenu(callback) {
      isSubMenuHiding.value = true;
      setTimeout(function () {
        isSubMenuHiding.value = false;
      }, animationDuration);

      // アニメーションさせるために少し待つ
      setTimeout(callback, 100);
    };
    var handleMenuTriggerClick = function handleMenuTriggerClick() {
      isShowMenu.value = !isShowMenu.value;
      resetSelectedMenuItem();
    };
    var handleOutsideClick = function handleOutsideClick(updatedIsShowMenu) {
      isShowMenu.value = updatedIsShowMenu;
      resetSelectedMenuItem();
    };
    var resetSelectedMenuItem = function resetSelectedMenuItem() {
      selectedMenuItem.value = null;
    };
    var backToBeforeMenu = function backToBeforeMenu() {
      startHidingSubMenu(resetSelectedMenuItem);
    };
    var selectedMenuItem = ref(null);
    var menuItems = computed(function () {
      var _auth$user$organizati;
      return [].concat(_toConsumableArray(buildFirstGroupMenu(auth.permissions)), _toConsumableArray(buildSecondGroupMenu()), _toConsumableArray(buildThirdGroupMenu((_auth$user$organizati = auth.user.organization.config) === null || _auth$user$organizati === void 0 ? void 0 : _auth$user$organizati.enableNewsPanelSwitch)));
    });
    var menuItemsCountsLoading = ref(false);
    var menuItemsCounts = ref({
      newsCategory: null,
      publisher: null,
      format: null,
      guideline: null,
      publicComment: null
    });

    // それぞれの全数
    var getMenuItemsCounts = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var countsPromises, _yield$Promise$allSet, _yield$Promise$allSet2, newsCategoriesCount, publishersCount, formatCategoriesCount, guidelinesCount, publicCommentsCount, handleResponse;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              menuItemsCountsLoading.value = true;
              countsPromises = [$repositories.news.getNewsCount(), $repositories.books.getCount(), $repositories.format.getFormatFileCount(), $repositories.guidelines.getCount(), $repositories.publicComments.getCount()];
              _context.n = 1;
              return Promise.allSettled(countsPromises);
            case 1:
              _yield$Promise$allSet = _context.v;
              _yield$Promise$allSet2 = _slicedToArray(_yield$Promise$allSet, 5);
              newsCategoriesCount = _yield$Promise$allSet2[0];
              publishersCount = _yield$Promise$allSet2[1];
              formatCategoriesCount = _yield$Promise$allSet2[2];
              guidelinesCount = _yield$Promise$allSet2[3];
              publicCommentsCount = _yield$Promise$allSet2[4];
              handleResponse = function handleResponse(key, res) {
                var isFulFilled = res.status === 'fulfilled';
                if (isFulFilled) {
                  menuItemsCounts.value[key] = res.value;
                  return;
                }
                console.error(res.reason);
              };
              handleResponse('newsCategory', newsCategoriesCount);
              handleResponse('publisher', publishersCount);
              handleResponse('format', formatCategoriesCount);
              handleResponse('guideline', guidelinesCount);
              handleResponse('publicComment', publicCommentsCount);
              menuItemsCountsLoading.value = false;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getMenuItemsCounts() {
        return _ref.apply(this, arguments);
      };
    }();

    // メニュー各項目内のコンテンツおよび key 別カウントの取得
    var menuItemActions = {
      newsCategory: function newsCategory() {
        if (newsCategories.value === null) {
          getNewsCategories();
        }
        if (subMenuCounts.value.newsCategory === null) {
          getNewsCategoryCounts();
        }
      },
      publisher: function publisher() {
        if (publishers.value === null) {
          getPublishers();
        }
        if (subMenuCounts.value.publisher === null) {
          getPublisherCounts();
        }

        // 購入済み書籍のカウントはサブメニューを開くたびに取得する
        getPurchasedDocumentsCount();
      },
      format: function format() {
        if (formatCategories.value === null) {
          getFormatCategories();
        }
        if (subMenuCounts.value.format === null) {
          getFormatCategoryCounts();
        }
      },
      guideline: function guideline() {
        if (guidelines.value === null) {
          getGuidelines();
        }
        if (subMenuCounts.value.guideline === null) {
          getGuidelineCounts();
        }
      },
      publicComment: function publicComment() {
        if (publicComments.value === null) {
          getPublicComments();
        }
        if (subMenuCounts.value.publicComment === null) {
          getPublicCommentCounts();
        }
      },
      collection: function collection() {
        isShowMenu.value = false;
        router.push('/collections');
      },
      history: function history() {
        // 履歴はサブメニューを開くたびに取得する
        getHistories();
      },
      announce: function announce() {
        isShowMenu.value = false;
        window.open('https://lp.legalscape.jp/release-note', '_blank', 'noopener,noreferrer');
      },
      showNewsPanel: function showNewsPanel() {
        isShowMenu.value = false;
        var showNewsPanel = store.state.persistent.showNewsPanel;
        store.commit('setShowNewsPanel', !showNewsPanel);
      }
    };
    var handleMenuItemClick = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(key) {
        var animationTargets;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(selectedMenuItem.value === key)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              animationTargets = [].concat(_toConsumableArray(Object.keys(subMenus.value)), ['history', 'account', 'help']);
              if (animationTargets.includes(key)) {
                startShowingSubMenu(function () {
                  selectedMenuItem.value = key;
                });
              }
              if (key in menuItemActions) {
                menuItemActions[key]();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function handleMenuItemClick(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    onMounted(function () {
      getMenuItemsCounts();
    });

    // =================
    // サブメニュー
    // =================
    // 共通
    var formatSubMenusCounts = function formatSubMenusCounts(counts) {
      return counts.reduce(function (acc, cur) {
        acc[cur.key] = cur;
        return acc;
      }, {});
    };

    // 検索ページへの遷移に関する処理
    var store = useStore();
    var routeChanging = computed(function () {
      return store.state.global.routeChanging;
    });
    var storedPerPage = computed(function () {
      return store.state.persistent.perPage;
    });
    var storedOrderId = computed(function () {
      return store.state.search.orderId;
    });
    var storedOption = computed(function () {
      return {
        n: storedPerPage.value || Constants.Search.PerPage,
        o: storedOrderId.value || Constants.Search.OrderId
      };
    });
    var goToSearchPage = function goToSearchPage(documentType, publisher) {
      if (routeChanging.value) {
        return;
      }

      // SERP以外では詳細検索が画面に表示されていないので、以下をデフォルトとして検索する
      var query = {
        keyword: '',
        type: [documentType],
        publisher: [publisher],
        maxGaps: Constants.Search.DefaultMaxGaps,
        includeOlderEditions: false
      };
      var to = generateSearchRoute(query, storedOption.value);

      // 画面上部にスクロールする
      scrollToTop();
      router.push(to);
    };

    // ニュースカテゴリ
    var loadingNewsCategories = ref(false);
    var newsCategories = ref(null);
    var formattedNewsCategories = computed(function () {
      var _newsCategories$value;
      var list = (_newsCategories$value = newsCategories.value) === null || _newsCategories$value === void 0 ? void 0 : _newsCategories$value.map(function (category) {
        return {
          title: category.name,
          value: NEWS_CATEGORIES_DIRECTORIES[category.name]
        };
      });
      return list || [];
    });
    var getNewsCategories = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              loadingNewsCategories.value = true;
              _context3.p = 1;
              _context3.n = 2;
              return $repositories.users.getUserNewsCategories();
            case 2:
              res = _context3.v;
              newsCategories.value = res.newsCategories;
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t = _context3.v;
              toast.error('ニュースカテゴリの取得に失敗しました');
            case 4:
              loadingNewsCategories.value = false;
            case 5:
              return _context3.a(2);
          }
        }, _callee3, null, [[1, 3]]);
      }));
      return function getNewsCategories() {
        return _ref3.apply(this, arguments);
      };
    }();
    var getNewsCategoryCounts = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var counts, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return $repositories.news.getNewsCountByCategory();
            case 1:
              counts = _context4.v;
              subMenuCounts.value.newsCategory = formatSubMenusCounts(counts);
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t2 = _context4.v;
              console.error(_t2);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 2]]);
      }));
      return function getNewsCategoryCounts() {
        return _ref4.apply(this, arguments);
      };
    }();
    var handleNewsCategoryClick = function handleNewsCategoryClick(value) {
      var path = value === 'all' ? '/directories' : "/directories/".concat(value);
      router.push(path);
    };

    // 書籍・雑誌
    var loadingPublishers = ref(false);
    var publishers = ref(null);
    var formattedPublishers = computed(function () {
      var _publishers$value;
      var list = (_publishers$value = publishers.value) === null || _publishers$value === void 0 ? void 0 : _publishers$value.map(function (publisher) {
        return {
          title: publisher,
          value: publisher
        };
      });
      return [].concat(_toConsumableArray(PUBLISHER_SUB_MENUS), _toConsumableArray(list || []));
    });
    var getPublishers = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              loadingPublishers.value = true;
              _context5.p = 1;
              _context5.n = 2;
              return $repositories.publishers.listPublisherNames(DocumentTypeEnum.Book);
            case 2:
              publishers.value = _context5.v;
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t3 = _context5.v;
              toast.error('書籍・雑誌の取得に失敗しました');
            case 4:
              loadingPublishers.value = false;
            case 5:
              return _context5.a(2);
          }
        }, _callee5, null, [[1, 3]]);
      }));
      return function getPublishers() {
        return _ref5.apply(this, arguments);
      };
    }();
    var getPublisherCounts = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var counts, _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return $repositories.books.getCountByPublisher();
            case 1:
              counts = _context6.v;
              subMenuCounts.value.publisher = _objectSpread(_objectSpread({}, subMenuCounts.value.publisher), formatSubMenusCounts(counts));
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t4 = _context6.v;
              console.error(_t4);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, null, [[0, 2]]);
      }));
      return function getPublisherCounts() {
        return _ref6.apply(this, arguments);
      };
    }();
    var getPurchasedDocumentsCount = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _yield$$repositories$, count, _t5;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              _context7.n = 1;
              return $repositories.users.purchasedDocumentsCount();
            case 1:
              _yield$$repositories$ = _context7.v;
              count = _yield$$repositories$.count;
              subMenuCounts.value.publisher = _objectSpread(_objectSpread({}, subMenuCounts.value.publisher), {}, {
                購入済み書籍: {
                  key: '購入済み書籍',
                  count: count
                }
              });
              _context7.n = 3;
              break;
            case 2:
              _context7.p = 2;
              _t5 = _context7.v;
              console.error(_t5);
            case 3:
              return _context7.a(2);
          }
        }, _callee7, null, [[0, 2]]);
      }));
      return function getPurchasedDocumentsCount() {
        return _ref7.apply(this, arguments);
      };
    }();
    var handlePublisherClick = function handlePublisherClick(value) {
      var isRoutePath = value.startsWith('/');
      if (isRoutePath) {
        router.push(value);
        return;
      }
      goToSearchPage(DocumentTypeEnum.Book, value);
    };

    // 書式ファイル
    var loadingFormatCategories = ref(false);
    var formatCategories = ref(null);
    var formattedFormatCategories = computed(function () {
      var _formatCategories$val;
      var list = (_formatCategories$val = formatCategories.value) === null || _formatCategories$val === void 0 ? void 0 : _formatCategories$val.map(function (formatCategory) {
        return {
          title: formatCategory.name,
          value: String(formatCategory.id)
        };
      });
      return list || [];
    });
    var getFormatCategories = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _t6;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              loadingFormatCategories.value = true;
              _context8.p = 1;
              _context8.n = 2;
              return $repositories.format.getCategories();
            case 2:
              formatCategories.value = _context8.v;
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t6 = _context8.v;
              toast.error('書式ファイルの取得に失敗しました');
            case 4:
              loadingFormatCategories.value = false;
            case 5:
              return _context8.a(2);
          }
        }, _callee8, null, [[1, 3]]);
      }));
      return function getFormatCategories() {
        return _ref8.apply(this, arguments);
      };
    }();
    var getFormatCategoryCounts = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _yield$$repositories$2, counts, _t7;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              _context9.n = 1;
              return $repositories.format.getFormatCategoriesCount();
            case 1:
              _yield$$repositories$2 = _context9.v;
              counts = _yield$$repositories$2.counts;
              subMenuCounts.value.format = formatSubMenusCounts(counts);
              _context9.n = 3;
              break;
            case 2:
              _context9.p = 2;
              _t7 = _context9.v;
              console.error(_t7);
            case 3:
              return _context9.a(2);
          }
        }, _callee9, null, [[0, 2]]);
      }));
      return function getFormatCategoryCounts() {
        return _ref9.apply(this, arguments);
      };
    }();
    var handleFormatCategoryClick = function handleFormatCategoryClick(categoryId, subcategoryTitle) {
      var path = "/format/categories/".concat(categoryId, "/subcategories");
      if (subcategoryTitle) {
        path += "#".concat(subcategoryTitle);
      }
      router.push(path);
    };

    // ガイドライン
    var loadingGuidelines = ref(false);
    var guidelines = ref(null);
    var formattedGuidelines = computed(function () {
      var _guidelines$value;
      var list = (_guidelines$value = guidelines.value) === null || _guidelines$value === void 0 ? void 0 : _guidelines$value.map(function (guideline) {
        return {
          title: guideline,
          value: guideline
        };
      });
      return list || [];
    });
    var getGuidelines = /*#__PURE__*/function () {
      var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var _t8;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              loadingGuidelines.value = true;
              _context0.p = 1;
              _context0.n = 2;
              return $repositories.publishers.listPublisherNames(DocumentTypeEnum.Guideline);
            case 2:
              guidelines.value = _context0.v;
              _context0.n = 4;
              break;
            case 3:
              _context0.p = 3;
              _t8 = _context0.v;
              toast.error('ガイドラインの取得に失敗しました');
            case 4:
              loadingGuidelines.value = false;
            case 5:
              return _context0.a(2);
          }
        }, _callee0, null, [[1, 3]]);
      }));
      return function getGuidelines() {
        return _ref0.apply(this, arguments);
      };
    }();
    var getGuidelineCounts = /*#__PURE__*/function () {
      var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var counts, _t9;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              _context1.p = 0;
              _context1.n = 1;
              return $repositories.guidelines.getCountByPublisher();
            case 1:
              counts = _context1.v;
              subMenuCounts.value.guideline = formatSubMenusCounts(counts);
              _context1.n = 3;
              break;
            case 2:
              _context1.p = 2;
              _t9 = _context1.v;
              console.error(_t9);
            case 3:
              return _context1.a(2);
          }
        }, _callee1, null, [[0, 2]]);
      }));
      return function getGuidelineCounts() {
        return _ref1.apply(this, arguments);
      };
    }();
    var handleGuidelineClick = function handleGuidelineClick(value) {
      goToSearchPage(DocumentTypeEnum.Guideline, value);
    };

    // パブコメ
    var loadingPublicComments = ref(false);
    var publicComments = ref(null);
    var formattedPublicComments = computed(function () {
      var _publicComments$value;
      var list = (_publicComments$value = publicComments.value) === null || _publicComments$value === void 0 ? void 0 : _publicComments$value.map(function (publicComment) {
        return {
          title: publicComment,
          value: publicComment
        };
      });
      return list !== null && list !== void 0 ? list : [];
    });
    var getPublicComments = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var _t0;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              loadingPublicComments.value = true;
              _context10.p = 1;
              _context10.n = 2;
              return $repositories.publishers.listPublisherNames(DocumentTypeEnum.Pubcom);
            case 2:
              publicComments.value = _context10.v;
              _context10.n = 4;
              break;
            case 3:
              _context10.p = 3;
              _t0 = _context10.v;
              toast.error('パブコメの取得に失敗しました');
            case 4:
              loadingPublicComments.value = false;
            case 5:
              return _context10.a(2);
          }
        }, _callee10, null, [[1, 3]]);
      }));
      return function getPublicComments() {
        return _ref10.apply(this, arguments);
      };
    }();
    var getPublicCommentCounts = /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var counts, _t1;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              _context11.p = 0;
              _context11.n = 1;
              return $repositories.publicComments.getCountByPublisher();
            case 1:
              counts = _context11.v;
              subMenuCounts.value.publicComment = formatSubMenusCounts(counts);
              _context11.n = 3;
              break;
            case 2:
              _context11.p = 2;
              _t1 = _context11.v;
              console.error(_t1);
            case 3:
              return _context11.a(2);
          }
        }, _callee11, null, [[0, 2]]);
      }));
      return function getPublicCommentCounts() {
        return _ref11.apply(this, arguments);
      };
    }();
    var handlePublicCommentClick = function handlePublicCommentClick(value) {
      goToSearchPage(DocumentTypeEnum.Pubcom, value);
    };
    var subMenus = computed(function () {
      return {
        newsCategory: formattedNewsCategories.value,
        publisher: formattedPublishers.value,
        format: formattedFormatCategories.value,
        guideline: formattedGuidelines.value,
        publicComment: formattedPublicComments.value
      };
    });
    var subMenuLoadings = computed(function () {
      return {
        newsCategory: loadingNewsCategories.value,
        publisher: loadingPublishers.value,
        format: loadingFormatCategories.value,
        guideline: loadingGuidelines.value,
        publicComment: loadingPublicComments.value
      };
    });
    var subMenuCounts = ref({
      newsCategory: null,
      publisher: null,
      format: null,
      guideline: null,
      publicComment: null
    });
    var handleSubMenuItemClick = function handleSubMenuItemClick(key, subItem) {
      var _subItem$value, _subItem$value2, _subItem$value3, _subItem$value4, _subItem$value5;
      switch (key) {
        case 'newsCategory':
          handleNewsCategoryClick((_subItem$value = subItem.value) !== null && _subItem$value !== void 0 ? _subItem$value : '');
          break;
        case 'publisher':
          handlePublisherClick((_subItem$value2 = subItem.value) !== null && _subItem$value2 !== void 0 ? _subItem$value2 : '');
          break;
        case 'format':
          handleFormatCategoryClick((_subItem$value3 = subItem.value) !== null && _subItem$value3 !== void 0 ? _subItem$value3 : '');
          break;
        case 'guideline':
          handleGuidelineClick((_subItem$value4 = subItem.value) !== null && _subItem$value4 !== void 0 ? _subItem$value4 : '');
          break;
        case 'publicComment':
          handlePublicCommentClick((_subItem$value5 = subItem.value) !== null && _subItem$value5 !== void 0 ? _subItem$value5 : '');
          break;
        default:
          break;
      }
      isShowMenu.value = false;
    };

    // =================
    // 履歴
    // =================
    var isHistoriesLoading = ref(false);
    var histories = ref([]);
    var getHistories = /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var historyOffset, nToShow, _yield$Promise$all, _yield$Promise$all2, docs, searches, sortedHistory, _t10;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              _context12.p = 0;
              isHistoriesLoading.value = true;
              historyOffset = 0; // 履歴データをfromいくつから取得すればよいか
              nToShow = Constants.Portal.PerPage;
              _context12.n = 1;
              return Promise.all([$repositories.histories.getDocHistories(historyOffset, nToShow), $repositories.histories.getSearchHistories(historyOffset, nToShow)]);
            case 1:
              _yield$Promise$all = _context12.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              docs = _yield$Promise$all2[0];
              searches = _yield$Promise$all2[1];
              // 結合したものを時系列順に並べるのは本来は間違っている。
              // (そもそもユーザーの "一連の" 行動を記録するということを目的としたデータの採取を考える必要がある。)
              sortedHistory = [].concat(_toConsumableArray(docs.excerpt), _toConsumableArray(searches.excerpt)).sort(function (a, b) {
                return b.timeStamp.localeCompare(a.timeStamp);
              });
              histories.value = sortedHistory.slice(0, nToShow);
              _context12.n = 3;
              break;
            case 2:
              _context12.p = 2;
              _t10 = _context12.v;
              console.error(_t10);
            case 3:
              _context12.p = 3;
              isHistoriesLoading.value = false;
              return _context12.f(3);
            case 4:
              return _context12.a(2);
          }
        }, _callee12, null, [[0, 2, 3, 4]]);
      }));
      return function getHistories() {
        return _ref12.apply(this, arguments);
      };
    }();
    var disablePersonalFeature = computed(function () {
      return domain.isMHMMypage;
    });
    var handleHistoryAnchorClick = function handleHistoryAnchorClick() {
      isShowMenu.value = false;
    };
    return {
      __sfc: true,
      router: router,
      domain: domain,
      $repositories: $repositories,
      toast: toast,
      auth: auth,
      isShowMenu: isShowMenu,
      animationDuration: animationDuration,
      isSubMenuShowing: isSubMenuShowing,
      isSubMenuHiding: isSubMenuHiding,
      startShowingSubMenu: startShowingSubMenu,
      startHidingSubMenu: startHidingSubMenu,
      handleMenuTriggerClick: handleMenuTriggerClick,
      handleOutsideClick: handleOutsideClick,
      resetSelectedMenuItem: resetSelectedMenuItem,
      backToBeforeMenu: backToBeforeMenu,
      selectedMenuItem: selectedMenuItem,
      menuItems: menuItems,
      menuItemsCountsLoading: menuItemsCountsLoading,
      menuItemsCounts: menuItemsCounts,
      getMenuItemsCounts: getMenuItemsCounts,
      menuItemActions: menuItemActions,
      handleMenuItemClick: handleMenuItemClick,
      formatSubMenusCounts: formatSubMenusCounts,
      store: store,
      routeChanging: routeChanging,
      storedPerPage: storedPerPage,
      storedOrderId: storedOrderId,
      storedOption: storedOption,
      goToSearchPage: goToSearchPage,
      loadingNewsCategories: loadingNewsCategories,
      newsCategories: newsCategories,
      formattedNewsCategories: formattedNewsCategories,
      getNewsCategories: getNewsCategories,
      getNewsCategoryCounts: getNewsCategoryCounts,
      handleNewsCategoryClick: handleNewsCategoryClick,
      loadingPublishers: loadingPublishers,
      publishers: publishers,
      formattedPublishers: formattedPublishers,
      getPublishers: getPublishers,
      getPublisherCounts: getPublisherCounts,
      getPurchasedDocumentsCount: getPurchasedDocumentsCount,
      handlePublisherClick: handlePublisherClick,
      loadingFormatCategories: loadingFormatCategories,
      formatCategories: formatCategories,
      formattedFormatCategories: formattedFormatCategories,
      getFormatCategories: getFormatCategories,
      getFormatCategoryCounts: getFormatCategoryCounts,
      handleFormatCategoryClick: handleFormatCategoryClick,
      loadingGuidelines: loadingGuidelines,
      guidelines: guidelines,
      formattedGuidelines: formattedGuidelines,
      getGuidelines: getGuidelines,
      getGuidelineCounts: getGuidelineCounts,
      handleGuidelineClick: handleGuidelineClick,
      loadingPublicComments: loadingPublicComments,
      publicComments: publicComments,
      formattedPublicComments: formattedPublicComments,
      getPublicComments: getPublicComments,
      getPublicCommentCounts: getPublicCommentCounts,
      handlePublicCommentClick: handlePublicCommentClick,
      subMenus: subMenus,
      subMenuLoadings: subMenuLoadings,
      subMenuCounts: subMenuCounts,
      handleSubMenuItemClick: handleSubMenuItemClick,
      isHistoriesLoading: isHistoriesLoading,
      histories: histories,
      getHistories: getHistories,
      disablePersonalFeature: disablePersonalFeature,
      handleHistoryAnchorClick: handleHistoryAnchorClick,
      VBtn: VBtn,
      VList: VList,
      VListItem: VListItem,
      VListItemContent: VListItemContent,
      VListItemIcon: VListItemIcon,
      VListItemTitle: VListItemTitle,
      VMenu: VMenu,
      VSkeletonLoader: VSkeletonLoader,
      AccountMenuList: AccountMenuList,
      HelpMenuList: HelpMenuList,
      Icon: Icon,
      SiteMenuHistory: SiteMenuHistory,
      SiteMenuSub: SiteMenuSub
    };
  }
});